import { Controller } from "@hotwired/stimulus"

// Lightweight HTML5 drag-to-reorder. On drop, PATCHes the new id order to
// `urlValue`, which persists positions server-side.
//
// Sortables can be NESTED (measures inside a risk card inside the risks grid),
// and drag events bubble — every handler therefore ignores events that belong
// to an inner sortable, and the id harvest excludes inner sortables' rows.
export default class extends Controller {
  static values = { url: String }

  owns(event) {
    return event.target.closest('[data-controller~="sortable"]') === this.element
  }

  start(event) {
    if (!this.owns(event)) return
    this.dragged = event.target.closest("[data-sortable-id]")
    event.dataTransfer.effectAllowed = "move"
  }

  over(event) {
    if (!this.owns(event) || !this.dragged) return
    event.preventDefault()
    const target = event.target.closest("[data-sortable-id]")
    if (!target || target === this.dragged || target.parentElement !== this.dragged.parentElement) return
    const rect = target.getBoundingClientRect()
    const after = (event.clientY - rect.top) / rect.height > 0.5
    target.parentElement.insertBefore(this.dragged, after ? target.nextSibling : target)
  }

  drop(event) {
    if (!this.owns(event)) return
    event.preventDefault()
  }

  end(event) {
    if (event && !this.owns(event)) return
    if (!this.dragged) return
    this.dragged = null
    const ids = [...this.element.querySelectorAll("[data-sortable-id]")]
      .filter((el) => el.closest('[data-controller~="sortable"]') === this.element)
      .map((el) => el.dataset.sortableId)
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify({ ids })
    })
      .then((res) => { if (!res.ok) window.location.reload() })
      .catch(() => window.location.reload())
  }
}
